<div class="practice-detail" *ngIf="isTranslationLoaded">
  <!-- Breadcrumb Navigation and header-->
  <div class="breadcrumb-container">
    <app-personalized-practice-header
      [heading]="heading"
      [teamOptions]="teamOptions"
      [selectedTeams]="selectedTeams"
      [isLoadingTeams]="isLoadingTeams"
      (teamChange)="onTeamChange($event)"
    >
    </app-personalized-practice-header>
  </div>
</div>

<div class="practice-detail-content-wrapper">
  <qai-inner-wrap>
    <div class="card-container">
      <qai-reporting-card
        [title]="'reportingV2.TOTAL_TIME_SPENT_PRACTICING' | transloco"
        [value]="
          callSummaryData
            ? formatTimeInMinutes(
                callSummaryData.totalTimeSpentPracticingInMinutes
              )
            : '--'
        "
        align="start"
        [align]="'center'"
      >
      </qai-reporting-card>
      <qai-reporting-card
        [title]="'reportingV2.AVERAGE_SESSIONS_PER_USER' | transloco"
        [value]="
          callSummaryData
            ? callSummaryData.averageSessionsPerUser.toFixed(1) + ' sessions'
            : '--'
        "
        align="start"
        [align]="'center'"
      >
      </qai-reporting-card>
      <qai-reporting-card
        [title]="
          'reportingV2.MOST_COMMON_CONVERSATION_TYPE_SELECTION' | transloco
        "
        [value]="callSummaryData?.mostCommonCall?.callName || '--'"
        [align]="'center'"
        align="start"
      >
      </qai-reporting-card>
      <qai-reporting-card
        [title]="
          'reportingV2.LEAST_COMMON_CONVERSATION_TYPE_SELECTION' | transloco
        "
        [value]="callSummaryData?.leastCommonCall?.callName || '--'"
        [align]="'center'"
        align="start"
      >
      </qai-reporting-card>
    </div>
  </qai-inner-wrap>

  <app-reporting-personalized-practice-sessions
    [moduleUuid]="simulation?.moduleUuid || ''"
    [teamUuids]="selectedTeams"
    [productName]="simulation?.moduleName || ''"
  ></app-reporting-personalized-practice-sessions>
</div>
